//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tooltip from "../Tooltip.vue";
export default {
  components: {
    tooltip: Tooltip,
  },
  data: function(){
    return {
      formData: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit("activeDialog", false);
    },
    setLoginView() {
      this.$emit("loginView", true);
    },
    getFormData() {
      this.$emit("formDataUpdated", this.formData);
      this.formData.email = '';
      this.formData.password = '';
    },
  },
};
